<template>
    <MainContent title="Editar indumentaria">
        <template v-slot:header>
            <h3 class="card-title p-0">Editar indumentaria</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <FormIndumentaria v-if="!loading" :indumentaria="indumentaria" @terminado="editarIndumentaria"></FormIndumentaria>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import FormIndumentaria from '@/components/backend/bases/indumentarias/FormIndumentaria';

export default {
    data() {
        return {
            loading: false,
            indumentaria: null,
            indumentaria_id: this.$route.params.indumentaria_id
        }
    },
    methods: {
        getIndumentaria() {
            this.loading = true;
            const params = {
                indumentaria_id: this.indumentaria_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.show'), params).then(res => {
                this.indumentaria = res.data.data;
                this.loading = false;
            });
        },
        editarIndumentaria() {
            this.loading = true;
            this.indumentaria.filters = {};

            this.indumentaria.indumentaria_id = this.indumentaria_id;

            this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.update'), this.indumentaria).then(res => {
                this.$toast.success(res.data.message);
                this.$router.push({ name: 'back.bases.indumentarias.index' });
                this.loading = false;
            }).catch(error => {
                this.$toast.error(error.response.data.message);
                this.loading = false;
            });
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.editarIndumentaria();
            }
        }
    },
    created() {
        this.getIndumentaria();
    },
    components: { MainContent, FormIndumentaria }
}
</script>